<style lang="less" scoped>
.contian-absolute {
    // display: flex;
    height: 500px;
    // &>div {
    //     flex: 1;
    //     color: red;
    // }
    .one {
        width:40%;
        height:100%;
        display:inline-block;
        div {
            height: 100%;
        }
    }
    .two {
        width:30%;
        height:100%;
        display:inline-block;
        div {
            height: 100%;
        }
    }
}
</style>
<template>
  <div class="contian-absolute">
    <div
      class="one"
    >
      <div
        ref="one"
      />
    </div>
    <div
      class="two"
    >
      <div
        ref="two"
      />
    </div>
    <div
      class="two"
    >
      <div
        ref="three"
      />
    </div>
    <!-- <div ref="four" /> -->
  </div>
</template>
<script>
  import echarts from 'echarts'
  import { generate_three_option, handle_three_data } from './absolute_fields_three'
  import { generate_one_option, handle_one_data } from './absolute_fields_one'
  import { generate_two_option, handle_two_data } from './absolute_fields_two'
  import { formattingNumber } from './../utils'
  const index_hash = {
    0: 'income',
    1: 'user',
    2: 'new_user',
    3: 'old_user',
    4: 'unit_price'
  }
  const legend_data_hash = {
    income: ['上月同期MTD现金收入', '本月MTD现金收入'],
    user: ['上月同期MTD用户数', '本月MTD用户数'],
    new_user: ['上月同期MTD新用户数', '本月MTD用户数'],
    old_user: ['上月同期MTD老用户数', '本月MTD老用户数'],
    unit_price: ['上月同期平均客单价', '本月平均客单价'],
  }
  export default {
    props: {
      sourceData: {
        type: Object,
        default: () => ({})
      },
      rootTeamsHash: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      this.one = null
      this.two = null
      this.three = null
      this.four = null
      this.all_constants = ''
      return {}
    },
    mounted() {
      this.one = echarts.init(this.$refs['one'], 'walden')
      this.two = echarts.init(this.$refs['two'], 'walden')
      this.three = echarts.init(this.$refs['three'], 'walden')
      //this.four = echarts.init(this.$refs['four'],'walden')
      // this.two.setOption(TWO);
      // this.three.setOption(THREE);
      // this.four.setOption(FOUR);
    },
    methods: {
      one_set_option(order, current_data, type) {
        if (order.length !== 1) {
          order = [this.all_constants, ...order]
        }
        let max = -Infinity // 找出最大的
        const option = generate_one_option()
        const old_data_hash = current_data.last.team_data.reduce((total, item) => {
          total[item[0]] = item[1]
          max = Math.max(max, Number(item[1]))
          return total
        }, {})
        old_data_hash[this.all_constants] = Number(current_data.last.total || 0)
        const current_data_hash = current_data.current.team_data.reduce((total, item) => {
          total[item[0]] = item[1]
          max = Math.max(max, Number(item[1]))
          return total
        }, {})
        current_data_hash[this.all_constants] = Number(current_data.current.total || 0)
        max = Math.max(max, current_data_hash[this.all_constants], old_data_hash[this.all_constants])
        /* 设置echarts参数 */
        option.xAxis.min = -max
        option.xAxis.max = max
        option.legend.data = legend_data_hash[type]
        // option.legend.color = ['#EEB499','#C5CB81']
        option.yAxis[0].data = order.map(value => ({
          value:this.rootTeamsHash[value] === undefined ? value : this.rootTeamsHash[value].name, // 汇总直接显示
        }))
        if (type === 'income') {
          option.yAxis[0].name = '单位：万'  
          option.yAxis[0].nameTextStyle = {
            color: '#969696',
            padding: [0, 0, 0, 20]  
          }
        }
        option.series = [
          {
            name: option.legend.data[0],
            type: 'bar',
            stack: '总量',
            barWidth: 30,
            label: {
              show: false,
              position:'left',
            },
            data: order.map(item => handle_one_data(-old_data_hash[item], -max, 'left'))
          },
          {
            name: option.legend.data[1],
            type: 'bar',
            stack: '总量',
            barWidth: 30,
            label: {
              show: true,
              position:'right',
            },
            data: order.map(item => handle_one_data(current_data_hash[item], max, 'right'))
          },
        ]
        this.one.setOption(option);
      },
      two_set_option(order, current_data) {
        if (order.length !== 1) {
          order = [this.all_constants, ...order]
        }
        // let old_sum = 0
        // let current_sum = 0
        let max = -Infinity // 找出最大的
        const option = generate_two_option()
        const old_data_hash = current_data.last.team_data.reduce((total, item) => {
          total[item[0]] = item[1]
          // max = Math.max(max,Number(item[1]))
          return total
        }, {})
        old_data_hash[this.all_constants] = current_data.last.total
        const current_data_hash = current_data.current.team_data.reduce((total, item) => {
          total[item[0]] = item[1]
          // max = Math.max(max,Number(item[1]))
          return total
        }, {})
        current_data_hash[this.all_constants] = current_data.current.total
        /* --------------- echarts参数 ------------- */
        option.yAxis.data = order.map(value => {
          return this.rootTeamsHash[value] === undefined ? value : this.rootTeamsHash[value].name // 汇总直接显示
        })
        option.series[0].data = order.map(key => {
          const absolute = (Number(current_data_hash[key] || 0)) - Number((old_data_hash[key] || 0))
          max = Math.max(max, Math.abs(absolute))
          return absolute
        })
        option.series[0].data = option.series[0].data.map(item => handle_two_data(item, max))
        option.xAxis.min = -max
        option.xAxis.max = max
        option.tooltip.formatter = function(params) {
          const tar = params[0];
          return `${tar.name}<br/>${tar.seriesName}：${formattingNumber(tar.value)}`;
        }
        this.two.setOption(option);
      },
      three_set_option(order, current_data) {
        if (order.length !== 1) {
          order = [this.all_constants, ...order]
        }
        let max = -Infinity // 找出最大的
        const option = generate_three_option()
        const old_data_hash = current_data.last.team_data.reduce((total, item) => {
          total[item[0]] = item[1]
          // max = Math.max(max,Number(item[1]))
          return total
        }, {})
        old_data_hash[this.all_constants] = current_data.last.total
        const current_data_hash = current_data.current.team_data.reduce((total, item) => {
          total[item[0]] = item[1]
          // max = Math.max(max,Number(item[1]))
          return total
        }, {})
        current_data_hash[this.all_constants] = current_data.current.total
        /* --------------- echarts参数 ------------- */
        option.yAxis.data = order.map(value => {
          return this.rootTeamsHash[value] === undefined ? value : this.rootTeamsHash[value].name // 汇总直接显示
        })
        const order_data = order.map(key => {
          const absolute = Number(old_data_hash[key] || 0) === 0 ? Infinity : (Number(current_data_hash[key] || 0) - Number(old_data_hash[key] || 0)) / Number(old_data_hash[key] || 0) * 100
          if (![Infinity, -Infinity].includes(absolute)) {
            max = Math.max(max, Math.abs(absolute))
          }
          return [Infinity, -Infinity].includes(absolute) ? absolute : absolute
        })
        option.series[0].data = order_data.map(item => handle_three_data(item, Math.abs(max)))
        option.series[0].markPoint.data = order_data.map((item, index) => ({
          name: index + '',
          coord: [item, index],
          itemStyle: {
            // '#EEB499':'#C5CB81',
            color: item >= 0 ? '#EEB499' : '#C5CB81',
          }
        }))
        option.xAxis.min = -Math.abs(max)
        option.xAxis.max = Math.abs(max)
        option.tooltip.formatter = function(params) {
          const tar = params[0];
          return `${tar.name}<br/>${tar.seriesName}：${formattingNumber(tar.value, 2)}%`;
        }
        this.three.setOption(option);
      },
      set_all(index) {
        if (!this.sourceData) {
          return
        }
        this.all_constants = index === 4 ? '平均' : '汇总'
        // this.resize()
        const type = index_hash[index]
        let current_data = this.sourceData[type]
        if (index === 0) {
          current_data = {
            current: {
              team_data: current_data.current && current_data.current.team_data.map(item => [item[0], (Number(item[1] || 0) / 10000).toFixed(0)]),
              total: current_data.current && (Number(current_data.current.total || 0) / 10000).toFixed(0)
            },
            last: {
              team_data:current_data.last && current_data.last.team_data.map(item => [item[0], (Number(item[1] || 0) / 10000).toFixed(0)]),
              total: current_data.last && (Number(current_data.last.total || 0) / 10000).toFixed(0)
            }
          }
          //  current_data.team_data = current_data.team_data.map(item => (Number(item||0)/10000).toFixed(0))
        }
        const order = current_data.current.team_data.map(item => item[0])
        this.one_set_option(order, current_data, type)
        this.two_set_option (order, current_data, type)
        this.three_set_option(order, current_data, type)
        // this.four_set_option(order,current_data)
      },
      /*     resize () {
                this.one.resize()
                this.two.resize()
                this.three.resize()
                this.four.resize()
            }, */
      getResize() {
        return [ this.one.resize, this.two.resize, this.three.resize ]
      }
    }
  }
</script>
